import { ref } from "vue";
import { TaskDictionariesModel } from "../../../models";
import { AdapterService } from "../adapter";

export const useTaskDictionaries = () => {
  /**Адаптер */
  const adapter = new AdapterService();
  /**Списки для задачи */
  const dictionaries = ref(new TaskDictionariesModel());

  /**Получить список статусов */
  const getStatuses = async (queueId: string) => {
    const resp = await adapter.getStatuses(queueId);
    if (resp.IsSuccess) dictionaries.value.Statuses = resp.Value;
  };
  /**Получить список приоритетов */
  const getPriorities = async (queueId: string) => {
    const resp = await adapter.getPriorities(queueId);
    if (resp.IsSuccess) dictionaries.value.Priorities = resp.Value;
  };
  /**Получить список типов задач */
  const getTypeList = async (namespaceId: string) => {
    const resp = await adapter.getTypes(namespaceId);
    if (resp.IsSuccess) dictionaries.value.Types = resp.Value;
  };
  /**Получить список уровней сложности */
  const getDifficultyList = async (namespaceId: string) => {
    const resp = await adapter.getDifficultyList(namespaceId);
    if (resp.IsSuccess) dictionaries.value.Difficulties = resp.Value;
  };
  /**Получить список тегов */
  const getTags = async (projectId: number) => {
    const resp = await adapter.getTags(projectId);
    if (resp.IsSuccess) dictionaries.value.Tags = resp.Value;
  };
  /**Получить список сотрудников */
  const getEmployees = async (queueId: string) => {
    const resp = await adapter.getEmployees(queueId);
    if (resp.IsSuccess) dictionaries.value.Users = resp.Value;
  };

  /**Получить общие списки */
  const getDictionaries = async (queueId: string, projectId: number, namespaceId: string) => {
    await Promise.all([
      getStatuses(queueId),
      getPriorities(queueId),
      getTypeList(namespaceId.toString()),
      getDifficultyList(namespaceId),
      getTags(projectId),
      getEmployees(queueId.toString()),
    ]);
  };

  return {
    /**Получить общие списки */
    getDictionaries,
    /**Списки для задачи */
    dictionaries,
  };
};
